import React, { Component } from 'react'
import Link from 'gatsby-link'
class PrevNext extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { prev, next } = this.props
    return (
      <div className="prevnext-wrapper">
        <p className="prev">
          {prev && (
            <Link to={prev.frontmatter.path} className="a-animation">
              <span className="post-nav">Prev Post</span><br />
              <span className="post-link">{prev.frontmatter.title}</span>
            </Link>
          )}
        </p>
        <p className="next">
          {next && (
            <Link to={next.frontmatter.path} className="a-animation">
              <span className="post-nav">Next Post</span><br />
              <span className="post-link">{next.frontmatter.title}</span>
            </Link>
          )}
        </p>
      </div>
    )
  }
}

export default PrevNext



// WEBPACK FOOTER //
// ./src/components/PrevNext/PrevNext.jsx